import { surveyLocalization } from "survey-core";

export var swahiliStrings = {
  pagePrevText: "Iliyotangulia",
  pageNextText: "Ifuatayo",
  completeText: "Kamili",
  previewText: "Hakiki",
  editText: "Hariri",
  startSurveyText: "Anza",
  otherItemText: "Nyingine (eleza)",
  noneItemText: "Hakuna",
  selectAllItemText: "Chagua Zote",
  progressText: "Ukurasa {0} wa {1}",
  panelDynamicProgressText: "Rekodi {0} ya {1}",
  questionsProgressText: "Yaliyojibiwa {0}/{1} maswali",
  emptySurvey: "Hakuna ukurasa unaoonekana au swali katika utafiti.",
  completingSurvey: "Asanti kwa kukamilisha utafiti!",
  completingSurveyBefore:
    "Recodi zetu zinatuonyesha tayari umekamilisha utafiti.",
  loadingSurvey: "Tunaandaa utafiti...",
  optionsCaption: "Chagua...",
  value: "thamani",
  requiredError: "Tafadhali jibu hili swali.",
  requiredErrorInPanel: "Tafadhali jibu swali angalau moja.",
  requiredInAllRowsError: "Tafadhali jibu maswali katika safu zote.",
  numericError: "Thamani inapaswa kuwa ya nambari.",
  textMinLength: "Tafadhali ingiza angalau{0} husika.",
  textMaxLength: "Tafadhali ingiza isiozidi {0} husika.",
  textMinMaxLength:
    "Tafadhali ingiza kiwango zaidi ya {0} na kisichopungua {1} husika.",
  minRowCountError: "Tafadhali jaza isiopungua {0} safu.",
  minSelectError: "Tafadhali chagua angalau {0} lahaja.",
  maxSelectError: "Tafadhali changua isiozidi {0} lahaja.",
  numericMinMax:
    " '{0}' inapaswa kuwa sawa au zaidi ya {1} na sawa au chini ya {2}",
  numericMin: " '{0}'inapaswa kuwa sawa au zaidi ya {1}",
  numericMax: " '{0}'inapaswa kuwa sawa au chini ya {1}",
  invalidEmail: "Tafadhali ingiza anwani halali ya barua-pepe.",
  invalidExpression: "Usemi:{0} inapaswa kurudi 'kweli'.",
  urlRequestError: "Ombi lina kosa '{0}'. {1}",
  urlGetChoicesError:
    "Ombi lilirudisha data tupu au the 'path' mali ya njia sio sahihi",
  exceedMaxSize: "Saizi ya faili haipaswi kuzidi {0}.",
  otherRequiredError: "Tafadhali ingiza thamani nyingine.",
  uploadingFile:
    "Faili yako inapakia.Tafadhali subiri sekunde kadhaa na ujaribu tena.",
  loadingFile: "Inapakia...",
  chooseFile: "Chagua faili...",
  noFileChosen: "Hujachagua faili",
  confirmDelete: "Je! Unataka kufuta rekodi?",
  keyDuplicationError: "Thamani hii inapaswa kuwa ya kipekee.",
  addColumn: "Ongeza Kolamu",
  addRow: "Ongeza safu",
  removeRow: "Toa",
  addPanel: "Ongeza mpya",
  removePanel: "Toa",
  choices_Item: "kitu",
  matrix_column: "Kolamu",
  matrix_row: "Safu",
  savingData: "Matokeo yamehifadhiwa kwa seva...",
  savingDataError: "Kosa limetokea na hatukuweza kuhifadhi matokeo.",
  savingDataSuccess: "Matokeo yamehifadhiwa!",
  saveAgainButton: "Jaribu tena",
  timerMin: "dakika",
  timerSec: "sekunde",
  timerSpentAll: "Umetumia {0} kwenye ukurasa huu na {1} kwa jumla.",
  timerSpentPage: "Umetumia {0} kwenye ukurasa huu.",
  timerSpentSurvey: "Umetumia {0} kwa jumla.",
  timerLimitAll: "Umetumia {0} ya {1} kwenye ukurasa huu {2} wa {3} kwa jumla.",
  timerLimitPage: "Umetumia {0} ya {1} kwenye ukurasa huu.",
  timerLimitSurvey: "Umetumia {0} ya {1} kwa jumla.",
  cleanCaption: "Safisha",
  clearCaption: "Ondoa",
  chooseFileCaption: "Chagua faili",
  removeFileCaption: "Ondoa faili",
  booleanCheckedLabel: "Ndio",
  booleanUncheckedLabel: "Hapana",
  confirmRemoveFile: "Je! Una uhakika kuwa unataka kuondoa faili hii: {0}?",
  confirmRemoveAllFiles: "Je! Una uhakika kuwa unataka kuondoa faili zote?",
  questionTitlePatternText: "Kichwa cha Swali",
};

surveyLocalization.locales["sw"] = swahiliStrings;
surveyLocalization.localeNames["sw"] = "swahili";
